module.exports = __webpack_public_path__ + "static/media/capullo-2014.3dacb71d.png";


//////////////////
// WEBPACK FOOTER
// ./src/home/trip-advisor/capullo-2014.png
// module id = 653
// module chunks = 0